import React, { Fragment, useEffect, useState } from "react";
import CharterFila from "./CharterFila";
import SliderImagenes from "./SliderImagenes";
import Contenido from "./Contenido";
import Precio from "./Precio";
import SinPrecio from "./SinPrecio";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import {
  calcularTotalCapacidad,
  calcularTotalesHabitaciones,
  deJSAFechaAmericana,
  formatearFecha,
  manejadorDeRespuesta,
} from "../../../../utils/Tools";
import get from "../../../../utils/get";
import { chartersAPI } from "../../../../utils/funcionesAPI";
import Loader from "../../../Global/Loader";
// import { calcularPrecioCharter } from '../../../../utils/Tools'

const ProductoCuadro = (props) => {
  const {
    producto,
    onCharterClick,
    onProductoClick,
    origen,
    fecha = formatearFecha(deJSAFechaAmericana(new Date())),
    idCharterDeURL,
    destino,
    tarifaPorHabitacion,
    solosYsolas = false,
    pasajerosAdultos = [],
    promociones,
    esGrupoComercial,
    idPuntoDeEmbarque,
    idPuntoDeEmbarqueDeBarraOrdenar
  } = props;
  //FC descomentar cuando se vuelva a mostrar en pesos
  //let precio = Math.round(props.producto.tarifas[0].tarifaNeta * props.producto.moneda.cotizacion).toLocaleString();
  /*
    let precio = Math.round(producto.tarifas[0].tarifaNeta).toLocaleString();
    if (producto.charters.length > 0)
        //precio = Math.round((((props.producto.charters[0].tarifa.tarifaNeta - (props.producto.charters[0].tarifa.tarifaNeta * (props.producto.charters[0].promoValijaYa / 100)))) + props.producto.charters[0].tarifa.adicionalPorDia) * props.producto.moneda.cotizacion).toLocaleString();
        precio = Math.round((((producto.charters[0].tarifa.tarifaNeta - (producto.charters[0].tarifa.tarifaNeta * (producto.charters[0].promoValijaYa / 100)))) + producto.charters[0].tarifa.adicionalPorDia)).toLocaleString();
    */

  const [expanded, setExpanded] = useState(false);
  const [loaded, setLoaded] = useState(true);
  //const [itemsToShow, setItemsToShow] = useState(4);
  const [idCharterSeleccionado, setIdCharterSeleccionado] = useState(0);
  const [charterSeleccionado, setCharterSeleccionado] = useState(undefined);
  // const [habitacionesSeleccionadas, setHabitacionesSeleccionadas] = useState();
  const [totalesDeHabitaciones, setTotalesDeHabitaciones] = useState({});
  const [chartersBuscados, setChartersBuscados] = useState([]);

  useEffect(() => {
    if (tarifaPorHabitacion) {
      setTotalesDeHabitaciones(
        get(producto, "charters[0].totalesDeHabitaciones"),
        0
      );
      //calcularTotalesHabitaciones(get(producto, 'charters[0].idCharter', {}),  get(producto, 'charters[0].habitacionesElegidas'), origen, setTotalesDeHabitaciones);
    }
  }, [producto, pasajerosAdultos]);

  const handleCharterClick = (idCharter, e) => {
    if (!validarSolosYSolas(solosYsolas, pasajerosAdultos, destino)) {
      toast.info("Este producto no acepta solo 1 pasajero.", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    const charter = producto.charters.find(
      (char) => char.idCharter === idCharter
    );

    if (charter) {
      onCharterClick(charter);
      //FC descomentar cuando se vuelva a mostrar en pesos
      //const precioCharter = Math.round((((charter[0].tarifa.tarifaNeta - (charter[0].tarifa.tarifaNeta * (charter[0].promoValijaYa / 100)))) + charter[0].tarifa.adicionalPorDia) * this.props.producto.moneda.cotizacion).toLocaleString();
      // Math.round((((charter[0].tarifa.tarifaNeta - (charter[0].tarifa.tarifaNeta * (charter[0].promoValijaYa / 100)))) + charter[0].tarifa.adicionalPorDia)).toLocaleString();
      setIdCharterSeleccionado(idCharter);
      setCharterSeleccionado(charter);
      //this.setState({idCharterSeleccionado: idCharter, precioPaquete: precioCharter});
    }
  };

  const handleProductoClick = (e) => {
    if (!validarSolosYSolas(solosYsolas, pasajerosAdultos, destino)) {
      toast.info("Este producto no acepta solo 1 pasajero.", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    if (idCharterSeleccionado === 0) {
      e.preventDefault();
      toast.info("Debes seleccionar una salida para poder avanzar.", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    //FC: valido que el charter seleccionado sea del producto correspondiente y no de otro
    //const charterDeSession = JSON.parse(sessionStorage.getItem('charter'));
    const charter = producto.charters.find(
      (char) => char.idCharter === idCharterSeleccionado
    );

    if (!charter) {
      e.preventDefault();
      toast.info("No puede seleccionar una salida de otro producto.", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    sessionStorage.setItem("charter", JSON.stringify(charter));

    onProductoClick(producto);
  };

  //FC: es el btn comprar que cada charter tiene
  const handleComprarCharterClick = (idCharter, habitacionesElegidas, e) => {
    //const charter = producto.charters.find(
    const charter = chartersBuscados.find(
      (char) => char.idCharter === idCharter
    );

    if (tarifaPorHabitacion) {
      if (
        calcularTotalCapacidad(habitacionesElegidas) !== pasajerosAdultos.length
      ) {
        e.preventDefault();
        toast.info(
          "La cantidad de adultos no coincide con la totalidad de la capacidad de las habitaciones",
          {
            position: toast.POSITION.BOTTOM_CENTER,
          }
        );
        return;
      }

      charter.habitacionesElegidas = habitacionesElegidas;
    }

    onCharterClick(charter);
    setIdCharterSeleccionado(idCharter);
    onProductoClick(producto);

    //  this.props.history.push('/paquete-turistico/carga-pasajeros/');
  };

  const definirURLPeticion = (esGrupo, idEmbarque) => {
    let url = "traerChartersDeUnProductoConPuntoDeEmbarque";
    if (esGrupo) {
      url = "traerChartersDeUnGrupoParaWeb";
    }
    if (esGrupo && idEmbarque) {
      url = "traerChartersDeUnGrupoConEmbarque";
    }
      return url;
  }

  const handleBuscarChartersClick = (e) => {
    const data = JSON.stringify({
      peticion: definirURLPeticion(esGrupoComercial, idPuntoDeEmbarqueDeBarraOrdenar),
      idProducto: producto.idProducto,
      origen: producto.cabecera,
      adultos: pasajerosAdultos.length,
      fecha,
      canal: "WEB",
      soloValijaYa: promociones === "promociones",
      idGrupo: esGrupoComercial || 0,
      idPuntoDeEmbarque: idPuntoDeEmbarqueDeBarraOrdenar || idPuntoDeEmbarque,
      codigoDestino: destino || producto.destino.idDestino
    });
    setLoaded(false);
    setExpanded(true);
    chartersAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        setChartersBuscados(respuesta.data);
        setLoaded(true);
      }
    });

    //setIdCharterSeleccionado(idCharter);
  };

  const handleHabitacionesElegidasChange = (charter, habitacionesMod) => {
    calcularTotalesHabitaciones(
      charter.idCharter,
      habitacionesMod,
      producto.cabecera,
      setTotalesDeHabitaciones
    );
  };

  const handleVerMasClick = () => {
    setExpanded(!expanded);
    /*
    //FC: para ver cuanto mostrar, 4 8 o todos
    switch (itemsToShow) {
      case 4:
        if (producto.charters.length > 8) {
          setItemsToShow(8);
          setExpanded(false);
          //this.setState({ itemsToShow:  8, expanded: false })
        } else {
          setItemsToShow(producto.charters.length);
          setExpanded(true);
          //this.setState({ itemsToShow:  producto.charters.length, expanded: true })
        }
        break;
      case 8:
        setItemsToShow(producto.charters.length);
        setExpanded(true);
        // this.setState({ itemsToShow:  producto.charters.length, expanded: true })
        break;
      case producto.charters.length:
        setItemsToShow(4);
        setExpanded(false);
        // this.setState({ itemsToShow: 4, expanded: false })
        break;
      default:
    }
    */
  };

  const validarSolosYSolas = (esSolosYsolas, pasajeros, dest) => {
    if (!esSolosYsolas && pasajeros.length < 2 && dest !== "LMG") return false;
    return true;
  };


  return (
    <Fragment>
      <div className="notranslate result" id={producto.idProducto}>
        <div className="row">
          {/*SLIDER*/}
          <SliderImagenes  producto={producto} />
          {/*PARTE CENTRAL*/}
          <Contenido producto={producto} />
          {/*PARTE DERECHA*/}
          {producto.charters.length === 0 ? (
            <SinPrecio />
          ) : (
            <Precio
              producto={producto}
              tarifaPorHabitacion={tarifaPorHabitacion}
              charterSeleccionado={charterSeleccionado}
              onClickComprar={handleProductoClick}
              totalesDeHabitaciones={totalesDeHabitaciones}
            />
          )}

          <PlanFamily planesFamily={producto.planesFamily} />

          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 paquetes-disponibles">
            <ul>
              {producto.charters.length === 0 ? (
                <li className="row">
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <label>
                      Por el momento no hay salidas vigentes en este mes. Pruebe
                      en otro periodo
                    </label>
                  </div>
                </li>
              ) : (
                /*
              producto.charters.slice(0, itemsToShow).map((charter) => {
                return (
                  <CharterFila
                    key={charter.idCharter}
                    producto={producto}
                    tarifaPorHabitacion={tarifaPorHabitacion}
                    charter={charter}
                    origen={origen}
                    onCharterClick={handleCharterClick}
                    onComprarCharterClick={handleComprarCharterClick}
                    idCharterDeURL={idCharterDeURL}
                    idCharterSeleccionado={idCharterSeleccionado}
                    onChangeHabitacionesElegidas={
                      handleHabitacionesElegidasChange
                    }
                    pasajerosAdultos={pasajerosAdultos}
                  />
                );
              }) 
             */

                expanded && chartersBuscados.map((charter) => {
                  return (
                    <CharterFila
                      key={charter.idCharter}
                      producto={producto}
                      tarifaPorHabitacion={tarifaPorHabitacion}
                      charter={charter}
                      origen={producto.cabecera}
                      onCharterClick={handleCharterClick}
                      onComprarCharterClick={handleComprarCharterClick}
                      idCharterDeURL={idCharterDeURL}
                      idCharterSeleccionado={idCharterSeleccionado}
                      onChangeHabitacionesElegidas={
                        handleHabitacionesElegidasChange
                      }
                      pasajerosAdultos={pasajerosAdultos}
                    />
                  );
                })
              )}
            </ul>

            {
            chartersBuscados.length > 0 ? (
            <div
              className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ver-mas"
              onClick={handleVerMasClick}
            >
              {expanded ? (
                <button>
                  ver menos <i className="material-icons">keyboard_arrow_up</i>
                </button>
              ) : (
                <button>
                  <i className="material-icons alineacionIconoContenido">calendar_today</i>Ver fechas / Comprar
                </button>
              )}
            </div>
          ) : null
           }

            {chartersBuscados.length === 0 && !expanded ? (
              <div
                className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ver-mas"
                onClick={handleBuscarChartersClick}
              >
                <button><i className="material-icons alineacionIconoContenido">calendar_today</i>Ver fechas / Comprar</button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <Loader
        loaded={loaded}
        mensaje="Buscando Fechas, aguarde unos instantes..."
      />
    </Fragment>
  );
};
//FC: el withRouter es para poder hacer un this.props.history.push('/')
export default withRouter(ProductoCuadro);

function PlanFamily(props) {
  const planes = props.planesFamily;
  if (planes.length > 0) {
    return (
      <div className="divPlanFamily">
        <p style={{ margin: "0" }}>
          PLAN FAMILY: Descuentos especiales para familias de 2 adultos,
          compartiendo habitacion con 1 o 2 menores de entre 2 y 12 años.
        </p>
      </div>
    );
  }

  return "";
}

/*
<ul>
 {
   planes.map((plan) => {
        return <li key={plan.idPlan} >{plan.cantidadAdultos} mayores de 18 años y {plan.cantidadMenores} menores entre 2 y 17 años</li>
      })
    }
</ul>
{ producto.charters.length === 0 ? <li className="row">
  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
    <p>Sin salidas disponibles por el momento</p>
  </div>
</li> : null }

*/



// WEBPACK FOOTER //
// ./src/components/Resultados/ListadoProducto/ProductoCuadro/index.js